import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { newUnidadesTransporteSchema } from '@/shared';
import { useCreateUnidadesTransporte, useUpdateUnidadesTransporte } from '@/shared/actions/erp/system-settings';
import {
  CustomTextField,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { IDtaUnidadTransporte } from '@/shared/interfaces';

const returnUrl = '/parametrizacion/unidades-transporte';

export interface SaveUnidadesTransporteInterface {
  titlePage: string;
  editUnidadesTransporte?:IDtaUnidadTransporte;
}

type SaveFormData = {
  nombre: string;
  codigo: string;
  placa: string;
  chofer_nombre: string;
  chofer_identificacion: string;
};

const SaveUnidadesTransporte: React.FC<SaveUnidadesTransporteInterface> = ({ titlePage, editUnidadesTransporte }) => {
  
    const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

 
  ///* mutations
  const createUnidadesTransporteMutation = useCreateUnidadesTransporte(navigate, returnUrl);
  const updateUnidadesTransporteMutation = useUpdateUnidadesTransporte(navigate, returnUrl);


  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newUnidadesTransporteSchema),
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editUnidadesTransporte?.id_unidad_transporte) {
      return updateUnidadesTransporteMutation.mutate({
        id: editUnidadesTransporte.id_unidad_transporte,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createUnidadesTransporteMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editUnidadesTransporte) {
      setShrink(true);
      reset({
        codigo: editUnidadesTransporte.codigo,
        placa: editUnidadesTransporte.placa,
        chofer_nombre: editUnidadesTransporte.chofer_nombre,
        chofer_identificacion: editUnidadesTransporte.chofer_identificacion,
      } as any);
    }
  }, [editUnidadesTransporte]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrl);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        label="Nombre"
        error={errors.nombre}
        helperText={errors.nombre?.message}
        shrink={shrink}
        name='nombre'
        control={form.control}
      />
<CustomTextField
        label="codigo"
        error={errors.codigo}
        helperText={errors.codigo?.message}
        shrink={shrink}
        name='codigo'
        control={form.control}

      />
<CustomTextField
        label="placa"
        error={errors.placa}
        helperText={errors.placa?.message}
        shrink={shrink}
        name='placa'
        control={form.control}
      />
<CustomTextField 
        label="nombre del chofer"
        control={form.control}
        error={errors.chofer_nombre}
        helperText={errors.chofer_nombre?.message}
        shrink={shrink}
        name='chofer_nombre'
      />
        <CustomTextField
                label="identificacion del chofer"
                error={errors.chofer_identificacion}
                helperText={errors.chofer_identificacion?.message}
                shrink={shrink}
                name='chofer_identificacion'
                control={form.control}
        />
    </SingleFormBoxScene>

  );
};

export default SaveUnidadesTransporte;
